import styled from '@emotion/styled';
import {RebrandTheme} from "../../common/models/common.models";
const closeButton = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/close.svg';

export const ValidateError = styled.div`
    color: #dd6666;
    font-size: 16px;
    padding-top: 8px;
    font-family: MuseoSans-300;
    letter-spacing: 0.13px;
    text-align: center;
`;

export const Label = styled.label`
    display: block;
    font-size: 15px;
    color: #60738f;
    font-family: MuseoSans-300;
    letter-spacing: 0.14px;
    opacity: 1;
    margin-bottom: 0px;
    padding-bottom: 1px;
`;

export const LabelQuestion = styled(Label)`
    padding-top: 38px;
`;

export const SelectBoxWrapper = styled.div`
    width: 100%;
    margin-bottom: 29px;
`;

export const TextAreaWrapper = styled.div`
    width: 100%;
    margin-bottom: 41px;
`;

export const NameInputGroup = styled.div`
    width: 100%;
    margin-bottom: 23px;
    display: flex;
    justify-content: space-between;
`;

export const InputItem = styled.div`
    width: 203px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
`;

export const EmailInputGroup = styled.div`
    width: 100%;
    margin-bottom: 22px;
    display: flex;
    flex-direction: column;
`;

export const IndustriesInputGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 38px;
`;

export const PhoneAndCompanyInputGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 38px;
`;


export const SubmitButton = styled.div<{theme?: any}>`
    width: 100%;
    height: 51px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.footer.contactUs.button.backgroundColor} 0% 0% no-repeat padding-box;
    border-radius: 3px;
    opacity: 1;
    font-size: 18px;
    font-family: ${props => props.theme.footer.contactUs.button.fontFamily};
    color: #fff;
    cursor: pointer;
    :hover {
        background-color: ${props => props.theme.footer.contactUs.button.backgroundColorHover};
    }
    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 3px;
  }
`;

export const TextArea = styled.textarea<{error: boolean}>`
    width: 100%;
    height: 57px;
    resize: none;
    border-radius: 2px;
    opacity: 1;
    font-size: 15px;
    font-family: MuseoSans-300;
    letter-spacing: 0.04px;
    padding: 4px 9px;
    box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid ${props => (props.error ? '#DD6666' : '#CCCCCC')};
    background-color: ${props => (props.error ? '#FFE3E3' : '#FFFFFF')};
    transition: all 0.2s;
    ::placeholder {
        color: #b3c3da;
        font-size: 15px;
        font-family: MuseoSans-300;
        letter-spacing: 0.04px;
    }
    :focus {
        border: 1px solid #00a3e6;
        outline: none;
    }
`;

export const Title = styled.div<{theme?: any}>`
    font-size: 27px;
    font-family: ${props => props.theme.footer.contactUs.title.fontFamily};
    color: ${props => props.theme.footer.contactUs.title.color};
    letter-spacing: -0.81px;
    opacity: 1;
    border-top: 5px solid ${props => props.theme.footer.contactUs.title.borderTopColor};
    height: 60px;
    padding-top: 15px;
`;

export const InfoAreaWrapper = styled.div`
    width: 100%;
    height: 57px;
    resize: none;
`;
export const TextWrapper = styled.p`
    font-size: 15px;
    color: rgb(96, 115, 143);
    font-family: MuseoSans-300;
    letter-spacing: 0.14px;
`;

export const ContactUsFormWrapper = styled.div<{ breakLine: boolean }>`
  width: 100%;
  height: 100%;
  padding: 0 107px;
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: ${props => props.breakLine ? 'pre-line' : undefined};

  &:focus {
    outline: none;
  }
`;

export const CloseButton = styled.div<{ theme?: RebrandTheme }>`
    background-image: url(${closeButton});
    background-position: center;
    background-size: cover;
    position: absolute;
    right: 15.5px;
    top: 13.5px;
    height: 18px;
    width: 18px;
    cursor: pointer;

    &:focus-visible {
       outline: 4px solid ${props => props.theme.header.outlineColor};
       outline-offset: 0;
       border-radius: 4px;
  }
`;

export const ThankYouImage = styled.div<{theme?: any}>`
    background-image: url(${props => props.theme.footer.contactUs.success.image});
    background-position: center;
    background-size: cover;
    width: 180px;
    height: 180px;
`;

export const ThankYouMessage = styled.div<{theme?: any}>`
    font-size: 40px;
    font-family: ${props => props.theme.footer.contactUs.success.thankYou.fontFamily};
    text-align: center;
    margin: 63px 0px 40px 0px;
    color: ${props => props.theme.footer.contactUs.success.thankYou.color};
`;

export const SuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 655px;
    height: 620px;
`;

export const Response = styled.div<{theme?: any}>`
    font-family: ${props => props.theme.footer.contactUs.success.response.fontFamily};
    color: ${props => props.theme.footer.contactUs.success.response.color};
    font-size: 16px;
    width: 318px;
    text-align: center;
    line-height: 24px;
`;

export const getInputFieldCustomStyle = (error: boolean) => {
    return {
        padding: '0 9px',
        height: '31px',
        borderRadius: '2px',
        border: `1px solid ${error ? '#DD6666' : '#CCCCCC'}`,
        backgroundColor: `${error ? '#FFE3E3' : '#FFFFFF'}`,
        '-moz-appearance': 'textfield',
    };
};

export const getSelectBoxCustomStyle = (error: boolean) => {
    return {
        control: {
            border: `1px solid ${error ? '#DD6666' : '#CCCCCC'}`,
            backgroundColor: `${error ? '#FFE3E3' : '#FFFFFF'}`,
        },
        placeholder: {
            color: 'black',
        },
    };
};
